export function accessBootstrapMatchesUser(
  completedUid: string | null,
  currentUid: string | null
): boolean {
  return currentUid != null && completedUid === currentUid;
}

export function accessBootstrapRetryDelayMs(failedAttempt: number): number {
  return Math.min(1_000 * 2 ** Math.min(Math.max(failedAttempt, 0), 4), 15_000);
}

export function accessBootstrapFailureSignal(
  failedAttempt: number
): "breadcrumb" | "issue" | "none" {
  if (failedAttempt <= 0) return "breadcrumb";
  if (failedAttempt === 1) return "issue";
  return "none";
}
